// API Configuration
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Get the base URL without /api for assets
export const getAssetUrl = (path) => {
  if (!path) return null;
  
  // If it's already a full URL (from Cloudinary), return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Otherwise, construct URL with backend base
  const baseUrl = API_BASE.replace('/api', '');
  return `${baseUrl}${path}`;
};
